let instagramFeedSlider = $('.instagram-feed-slider');

$(instagramFeedSlider).flickity({
    lazyLoad: 2,
    imagesLoaded: true,
    draggable: true,
    cellAlign: (window.innerWidth >= 750) ? 'left' : 'center',
    wrapAround: true,
    pageDots: false,
    contain: true,
    prevNextButtons: false,
    initialIndex: 0,
    arrowShape: arrowShape,
    freeScroll: false,
    on: {
    ready: function() {
        // Resize flickity when the slider is settled
        $(instagramFeedSlider).on( 'settle.flickity', function() {
            $(instagramFeedSlider).flickity('resize')
        });
    }
    }
});